import * as React from 'react';
import CampfireButton from './CampfireButton';
import '../css/pinnedContent.sass';

interface PinnedContentProps {
  label: string;
  value: string;
  theme?: 'night' | 'day';
  rapButtonLabel: string;
  onRAPBtnClick?: Function;
  disableBtn?: boolean;
  hideBtn?: boolean;
  message?: React.ReactNode;
}

export default function PinnedContent(props: PinnedContentProps) {
  const { theme = 'day' } = props;
  return (
    <div
      className={`rapMobileAction mobileDisplay ${theme}`}
      id="rapMobileAction"
    >
      <div>
        <span className="rap-label">{props.label}</span>
        {!props.hideBtn && (
          <CampfireButton
            theme={theme}
            name="RAPButton"
            id="RAPButton"
            label={props.rapButtonLabel}
            color="water"
            smol
            onClick={props.onRAPBtnClick}
            disabled={props.disableBtn}
          />
        )}
        <div className="value">{props.value}</div>
      </div>
      {props.message}
    </div>
  );
}
